











import PlainInput from '../plain_input/index.vue'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useMessenger } from '@/hooks'
import { omit } from 'vtils'

export default defineClassComponent<{
  value: string
}>(
  {
    inheritAttrs: false,
    props: ['value'],
    components: {
      PlainInput,
    },
  },
  ({ props, ctx }) =>
    class {
      localValue = useMessenger(
        () => props.value,
        value => ctx.$emit('input', value),
      )

      listeners = computed(() => omit(ctx.$listeners, ['input', 'search']))

      handleSearch = () => {
        ctx.$emit('search')
      }
    },
)
